import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserDetails } from 'src/app/core/models/shared/UserDetails';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';

@Component({
  selector: 'app-es-user-details',
  templateUrl: './es-user-details.component.html',
})
export class EsUserDetailsComponent extends BaseComponent {
  @Input()
  userDetails?: UserDetails = null;

  @Input()
  contClasses?: string = "";

  constructor(translateService: TranslateService) {
    super(translateService);
  }
}
